import React from 'react'
import { HBox, Wrapper } from 'src/ui/layout'
import { Body, Header } from 'src/ui/typography'
import { styled } from 'src/ui/theme'
import { SwiperSlider } from 'src/ui/organisms'
import { CULTURE_DATA } from './constants'
import { SwiperSlide } from 'swiper/react/swiper-react.js'

const CultureItem = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`

const IconBlock = styled.div`
  padding: 9px;
  background-color: #f1f1f8;
`

export const Culture = () => {
  return (
    <Wrapper>
      <Header as="h4" size="h4">
        Корпоративная культура единомышленников
      </Header>

      <HBox height={32} />

      <SwiperSlider>
        {CULTURE_DATA.map((item) => (
          <SwiperSlide>
            <CultureItem>
              <IconBlock>{item.icon}</IconBlock>
              <Header as="h5" size="h5">
                {item.title}
              </Header>
              <Body>{item.body}</Body>
            </CultureItem>
          </SwiperSlide>
        ))}
      </SwiperSlider>
    </Wrapper>
  )
}
